import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/hisab-kitab`;

class HisabKitabServices {
  async getHisabKitabData({ page, limit, from, to, userId }) {
    try {
      const action = `${API_ROUTE}/get-hisab-kitab-data`;
      const params = { page, limit, from, to, userId };
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getHisabKitabData:", error);
      throw error;
    }
  }
}

export default HisabKitabServices;
